import React, { useState, useEffect } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import axios from 'axios';
import AttendanceModal from './AttendanceModal';
import { VIEW_ATTENDANCE_URL, ATTENDANCE_DETAILS_URL } from '../apiConfig';
import { Modal, Button, Spinner } from 'react-bootstrap';

const AttendanceCalendar = () => {
    const [date, setDate] = useState(new Date());
    const [classesByDay, setClassesByDay] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [attendance, setAttendance] = useState([]);
    const [isModalClassOpen, setIsModalClassOpen] = useState(false);
    const [isModalStudentOpen, setIsModalStudentOpen] = useState(false);
    const [selectedClass, setSelectedClass] = useState("");
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedStudent, setSelectedStudent] = useState(null);

    const token = localStorage.getItem('token');
    const headers = { Authorization: `Token ${token}` };
    const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');

    const fetchClasses = async (year, month) => {
        try {
            setLoading(true);
            const response = await axios.get(
                `${VIEW_ATTENDANCE_URL.replace('<int:year>', year).replace('<int:month>', month)}`,
                { headers }
            );
            setClassesByDay(response.data);
            setError(null);
        } catch (error) {
            console.error("Error fetching classes:", error);
            setError("Error fetching classes");
        } finally {
            setLoading(false);
        }
    };

    const fetchAttendance = async (classname, selectedDate) => {
        try {
            setLoading(true);
            setIsModalClassOpen(true);
            const formattedDate = selectedDate.toISOString().split('T')[0];
            const response = await axios.get(
                `${ATTENDANCE_DETAILS_URL.replace('<str:class_name>', classname).replace('<str:date>', formattedDate)}`,
                { headers }
            );
            setAttendance(response.data);
            setError(null);
        } catch (error) {
            console.error("Error fetching attendance:", error);
            setError("Error fetching attendance");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        document.body.className = theme;
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        fetchClasses(year, month);
    }, [date]);

    const getBadgeColor = (percentage) => {
        if (percentage >= 80) return "bg-success";
        if (percentage >= 50) return "bg-warning text-dark";
        return "bg-danger";
    };

    const renderTileContent = ({ date, view }) => {
        if (view === 'month') {
            const dayClasses = classesByDay.filter(classItem => {
                const classDate = new Date(classItem.date);
                return (
                    classDate.getFullYear() === date.getFullYear() &&
                    classDate.getMonth() === date.getMonth() &&
                    classDate.getDate() === date.getDate()
                );
            });

            return (
                <div>
                    {dayClasses.map((classItem, index) => {
                        const percentage = (classItem.total_students / classItem.total_classes * 100).toFixed(2);
                        return (
                            <div
                                key={index}
                                className="p-2 rounded shadow-sm mb-1"
                                style={{
                                    cursor: 'pointer',
                                    backgroundColor: theme === 'dark' ? '#2b2b2b' : '#f8f9fa',
                                    border: '1px solid #ccc'
                                }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setSelectedClass(classItem.statistic);
                                    setSelectedDate(date);
                                    fetchAttendance(classItem.statistic, date);
                                }}
                            >
                                <strong>{classItem.statistic}</strong>
                                <div>Alumnos: {classItem.total_students}</div>
                                <span className={`badge ${getBadgeColor(percentage)}`}>
                                    {percentage}%
                                </span>
                            </div>
                        );
                    })}
                </div>
            );
        }
    };

    const handleActiveStartDateChange = ({ activeStartDate }) => {
        setDate(activeStartDate);
    };

    return (
        <div>
            <div className={`container mt-5 w-100 h-100 p-4 d-flex flex-column justify-content-center ${theme === "light" ? "bg-light text-black" : "bg-dark text-white"}`}>
                {/* <h1 className='h1 p-5 m-auto'>Calendario de Clases</h1> */}
                {error && <p style={{ color: 'red' }}>{error}</p>}
                <div className='container d-flex flex-column justify-content-center'>
                    <div className="d-flex flex-column justify-content-center p-4">
                        <h3 className='h3 p-4 align-self-center'>Selecciona una clase</h3>
                        <Calendar
                            className={`calendar-container w-100 ${theme === 'dark' ? 'bg-dark text-white' : 'bg-light text-black'}`}
                            tileClassName={`${theme === 'dark' ? 'bg-dark text-white border' : 'bg-light text-black border border-dark'}`}
                            onActiveStartDateChange={handleActiveStartDateChange}
                            value={date}
                            tileContent={renderTileContent}
                        />
                    </div>
                </div>
            </div>

            {/* Modal de clase */}
            <Modal show={isModalClassOpen} onHide={() => setIsModalClassOpen(false)} size="lg">
                <Modal.Header closeButton
                
                    className={theme === 'dark' ? 'bg-dark text-white' : 'bg-light text-black'}>
                    <Modal.Title
                        className={theme === 'dark' ? 'text-white' : 'text-black'}>
                        Asistencia - {selectedClass} ({selectedDate?.toDateString()})
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body
                    className={theme === 'dark' ? 'bg-dark text-white' : 'bg-light text-black'}>
                    {loading ? (
                        <div className="d-flex justify-content-center p-5">
                            <Spinner animation="border" role="status" />
                        </div>
                    ) : attendance.length === 0 ? (
                        <p>No hay asistencia registrada para este día.</p>
                    ) : (
                        <table className={`table table-striped ${theme === 'dark' ? 'table-dark text-white' : 'bg-light text-black'}`}>
                            <thead>
                                <tr>
                                    <th>Nombre del alumno</th>
                                    <th>Observaciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {attendance.map((student, index) => (
                                    <tr 
                                        key={index}
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                            setSelectedStudent(student);
                                            student.first_name = student.name
                                            setIsModalStudentOpen(true);
                                        }}
                                    >
                                        <td>{student.name}</td>
                                        <td>{student.observations || 'Sin observaciones'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </Modal.Body>
                <Modal.Footer
                className={theme === 'dark' ? 'bg-dark text-white' : 'bg-light text-black'}
                >
                    <Button variant="secondary" onClick={() => setIsModalClassOpen(false)}>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal de alumno */}
            {isModalStudentOpen && (
                <AttendanceModal
                    show={isModalStudentOpen}
                    handleClose={() => setIsModalStudentOpen(false)}
                    student={selectedStudent}
                />
            )}
        </div>
    );
};

export default AttendanceCalendar;
